import VueMonthlyPicker from 'vue-monthly-picker';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from "@/assets/js/config.js";
import axios from 'axios';
import store from '@/store';
import ValidationService from '@/services/ValidationService';

export default {
	name: "myPayslipList",
	components: {
		MainLayout,
		Loading,
		CONFIG,
		VueMonthlyPicker,
		AdvancedLaravelVuePaginate,
		Select2Multiple,
	},

	mixins: [ValidationService],

	data() {
		return {
			payslipData: {},
			campusId: store.state.user.campus_id,
			noDataMsg: CONFIG.NO_DATA_FOUND,
			isLoading: false,
			searchData: {},
			statusArr: CONFIG.EMP_PAYMENT_STATUS,
			currentYearId: '',
			isSearch: 0,
			empTypeArr: CONFIG.EMPLOYEE_TYPE_CLASS,
			totalPaidAmount: 0,
			search_status: false,
			searchedData: null,
			isSearched: false,
		};
	},

	methods: {
		/**
		 * Fetch paginated payslips for the authenticated user.
		 *
		 * Applies current search filters, handles loading state and
		 * updates payslipData from the my/payslip/list API response.
		 *
		 * @param {number} isSearch Flag indicating search action (1: search, 0: initial load)
		 * @param {number} page Current page number for pagination
		 */
		getPayslips(isSearch = 1, page = 1) {
			this.searchData.is_search = isSearch;
			this.clearValidationErrors();
			this.isLoading = true;
			const params = { ...this.searchData };
			if (params.selectedMonth) {
				let month, year;
				if (params.selectedMonth instanceof Date) {
					month = params.selectedMonth.getMonth() + 1;
					year = params.selectedMonth.getFullYear();
				} else if (typeof params.selectedMonth === 'string' && params.selectedMonth.includes('/')) {
					const [m, y] = params.selectedMonth.split('/');
					month = parseInt(m, 10);
					year = parseInt(y, 10);
				} else {
					const d = new Date(params.selectedMonth);
					if (!isNaN(d.getTime())) {
						month = d.getMonth() + 1;
						year = d.getFullYear();
					}
				}
				if (month && year) {
					params.month = month;
					params.year = year;
				}
				delete params.selectedMonth;
			}
			axios
				.get('my/payslip/list?page=' + page, {
					params,
				})
				.then((res) => {
					if (res.data) {
						this.payslipData = res.data.payslip_data;
						this.isLoading = false;
					}
				})
				.catch((error) => {
					this.printValidationError(error.response);
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
					this.isLoading = false;
				});
		},

		/**
		 * Reset search filters to defaults and reload payslips.
		 *
		 * Clears searchData (except for authenticated employee_name),
		 * then triggers a fresh fetch of payslip data.
		 */
		reset() {
			this.searchData = {
				employee_name: store.state.user.name,
			};
			this.isLoading = true;
			this.getPayslips(1);
		},

		/**
		 * Download payslip PDF file for the given payslip record.
		 *
		 * Calls my/payslip/{id}/pdf-download endpoint, creates a blob URL
		 * from the response and triggers a browser download.
		 *
		 * @param {Object} payslip Payslip item containing id and display fields
		 */
		pdfDownload(payslip) {
			this.isLoading = true;
			axios
				.get(`/my/payslip/${payslip.id}/pdf-download`, {
					params: {
						campus_id: this.campusId,
					},
					responseType: 'blob',
					headers: {
						'Content-Type': 'application/pdf',
					},
				})
				.then((response) => {
					const fileURL = window.URL.createObjectURL(
						new Blob([response.data], { type: 'application/pdf' })
					);
					const fileLink = document.createElement('a');
					fileLink.href = fileURL;
					const fileName = `payslip_${payslip.employee_name}_${payslip.year}${
											payslip.month > 9 ? '' : '0'
										}${payslip.month}.pdf`;
					fileLink.setAttribute('download', fileName);
					document.body.appendChild(fileLink);
					fileLink.click();
					document.body.removeChild(fileLink);
					window.URL.revokeObjectURL(fileURL);
					this.isLoading = false;
				})
				.catch((error) => {
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
					this.isLoading = false;
				});
		},
	},

	mounted() {
		this.isLoading = true;
		this.getPayslips(1);
	},
};
